export default function() {
  return {
    computed:{
      Columns: function() {
        return this.columns;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/state/normal.js